import { Trans } from "@lingui/macro";
import { useLingui } from "@lingui/react";

import {
  selectTradeboxToToken,
  selectTradeboxTradeFlags,
} from "context/SyntheticsStateContext/selectors/tradeboxSelectors";
import { useSelector } from "context/SyntheticsStateContext/utils";
import { isPriceDataStale } from "domain/synthetics/trade/utils/validation";
import { formatTime } from "lib/dates";

import { AlertInfoCard } from "components/AlertInfo/AlertInfoCard";

function formatPriceSource(source?: string) {
  if (!source) {
    return "unknown";
  }

  return source.replace(/_/g, " ");
}

function formatUpdatedAt(updatedAt?: number) {
  if (!updatedAt) {
    return "unknown";
  }

  return formatTime(updatedAt);
}

export function PriceFeedStatusRow() {
  useLingui();
  const toToken = useSelector(selectTradeboxToToken);
  const { isPosition } = useSelector(selectTradeboxTradeFlags);

  if (!isPosition || !toToken) {
    return null;
  }

  const source = toToken.prices.source;
  const isFallbackSource = source === "db" || source === "default";
  const isStale = isPriceDataStale(toToken.prices.updatedAt);

  if (!isFallbackSource && !isStale) {
    return null;
  }

  const sourceLabel = formatPriceSource(source);
  const updatedAtLabel = formatUpdatedAt(toToken.prices.updatedAt);

  return (
    <AlertInfoCard type={isStale ? "warning" : "info"}>
      <Trans>
        Using {sourceLabel} price data for {toToken.symbol}. Last update: {updatedAtLabel}.
      </Trans>
    </AlertInfoCard>
  );
}
